import * as d3 from 'd3';
import { Format } from './Format';
import { RectFormat } from '../../charts/interfaces';
import { LineChartData } from '../../../models/LineChartData';

export function renderSymbol(
    selection: d3.selection.Update<RectFormat<LineChartData>>,
    scale: number = 0.5,
    stacked = false
) {
    selection
        .exit()
        .remove();
    selection
        .enter()
        .append('path')
        .classed('scatter-series', true);
    selection
        .attr('d', d => d.item.symbol(d))
        .attr('transform', d => {
            let y = d.y;
            
            if (stacked && d.item.value < 0) {
                y += d.height;
            }
            return `translate(${d.x},${y}) scale(${scale})`;
        })
        .style('stroke', d => d.color)
        .style('fill', d => d.color);
}

export function renderStackedSymbols(
    container: d3.Selection<RectFormat<LineChartData>>,
    series: Format[],
    scale = 0.5
): void {
    const filteredData = series
        .filter(r => r.series.isSymbolVisible())
        .map(r => {
            return {
                data: r.data.filter(d => d.item.value !== null),
                series: r.series
            } as Format;
        });
    const dataBound = container
        .selectAll('.symbols')
        .data(filteredData);
    dataBound
        .exit()
        .remove();
    dataBound
        .enter()
        .append('g')
        .classed('symbols', true)
        .classed('series-container', true)
        .attr('data-identifier', s => 'id' + s.series.identifier());
    dataBound
        .classed('hidden', d => !d.series.isVisible());
    const seriesBound = dataBound
        .selectAll('.scatter-series')
        .data(d => d.data);

    renderSymbol(seriesBound, scale, true);
}